import React from "react";

// Chakra imports
import { Flex, Image, Text, useColorModeValue } from "@chakra-ui/react";

// Custom components
import { HSeparator } from "../../../../components/admindashboard/separator/Separator";
import brandLogo from "../../../../assets/images/logo.png";

export function SidebarBrand() {
  //   Chakra color mode
  let logoColor = useColorModeValue("navy.700", "white");

  return (
    <Flex align='center' direction='column'>
      <Image
        src={brandLogo}
        alt='Hatha Yogashram'
        maxW='160px'
        my='20px'
        objectFit='contain'
      />
      <Text
        color={logoColor}
        fontSize='sm'
        fontWeight='700'
        letterSpacing='0.08em'
        textTransform='uppercase'
        mb='20px'
        textAlign='center'>
        Hatha Yogashram Admin
      </Text>
      <HSeparator mb='20px' />
    </Flex>
  );
}

export default SidebarBrand;
